/* Warenkorb-Baukasten (Drawer + Seite), Research/Warenkorb-Design-Runde2-1011.md §3.4.
   1. Lieferfenster mit Datum: dieselbe Rechnung wie die PDP-Kaufbox (snippets/rd-pdp-blocks.liquid, window.rdShip):
      Werktage Mo–Fr, bundesweite + bayerische Feiertage (Lager Regensburg), Sperrtage, Cutoff (Europe/Berlin).
      Auf der PDP gilt window.rdShip.range, damit Kaufbox und Warenkorb nie zwei Fenster zeigen.
   2. Geschenknachricht (Setting, Standard aus): schreibt in das Warenkorb-Attribut „Geschenknachricht“.
   3. „Weiter einkaufen“-Knöpfe im Drawer schließen ihn ([data-rd-wk-zu]).
   Läuft nach jedem Neuaufbau (cart:updated aus assets/cart.js), ohne cart.js zu verändern. */
(function () {
  if (window.__rdWkInit) return;
  window.__rdWkInit = true;

  var H = ['2026-01-01', '2026-04-03', '2026-04-06', '2026-05-01', '2026-05-14', '2026-05-25', '2026-10-03', '2026-12-25', '2026-12-26',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-17', '2027-10-03', '2027-12-25', '2027-12-26',
    /* bayerische Feiertage ohne Abholung (wie PDP): Hl. Drei Könige, Fronleichnam, Mariä Himmelfahrt, Allerheiligen */
    '2026-01-06', '2026-06-04', '2026-08-15', '2026-11-01', '2027-01-06', '2027-05-27', '2027-08-15', '2027-11-01'];
  var WD = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];

  function fenster(el) {
    var min = parseInt(el.dataset.min || '1', 10), max = parseInt(el.dataset.max || '3', 10), cut = parseInt(el.dataset.cut || '0', 10);
    var hol = H.concat((el.dataset.sperr || '').split(',').map(function (x) { return x.trim(); }).filter(function (x) { return /^\d{4}-\d{2}-\d{2}$/.test(x); }));
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
    function g(t) { var p = parts.find(function (x) { return x.type === t; }); return p ? parseInt(p.value, 10) : 0; }
    var d = new Date(Date.UTC(g('year'), g('month') - 1, g('day'))), hour = g('hour') % 24;
    function iso(x) { return x.toISOString().slice(0, 10); }
    function work(x) { var w = x.getUTCDay(); return w !== 0 && w !== 6 && hol.indexOf(iso(x)) < 0; }
    function add(x, n) { var y = new Date(x); while (n > 0) { y.setUTCDate(y.getUTCDate() + 1); if (work(y)) n--; } return y; }
    var base = new Date(d);
    if (cut > 0 && (!work(base) || hour >= cut)) base = add(base, 1);
    var e = add(base, min), l = add(base, max);
    function fn(x, m) { return WD[x.getUTCDay()] + ' ' + x.getUTCDate() + '.' + (m ? (x.getUTCMonth() + 1) + '.' : ''); }
    return fn(e, e.getUTCMonth() !== l.getUTCMonth()) + ' und ' + fn(l, true);
  }

  function lieferfenster() {
    document.querySelectorAll('[data-rd-wk-ship]').forEach(function (el) {
      var t = el.querySelector('[data-rd-wk-ship-t]');
      if (!t) return;
      var rng = window.rdShip && window.rdShip.range ? window.rdShip.range : fenster(el);
      t.textContent = 'Bei dir zwischen ' + rng;
      var sub = el.querySelector('[data-rd-wk-ship-sub]');
      if (sub) sub.hidden = false;
    });
  }

  /* Geschenknachricht → Warenkorb-Attribut (debounced); Zähler „noch N Zeichen“ */
  var notizT = null;
  function notizSpeichern(ta) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var st = ta.closest('[data-rd-wk-notiz-box]');
    var msg = st && st.querySelector('[data-rd-wk-notiz-status]');
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Geschenknachricht: ta.value.trim() } })
    }).then(function (r) {
      if (msg) msg.textContent = r.ok ? (ta.value.trim() ? 'Gespeichert.' : '') : 'Konnte nicht gespeichert werden.';
    }).catch(function () { if (msg) msg.textContent = 'Konnte nicht gespeichert werden.'; });
  }
  document.addEventListener('input', function (e) {
    var ta = e.target.closest && e.target.closest('[data-rd-wk-notiz]');
    if (!ta) return;
    clearTimeout(notizT);
    notizT = setTimeout(function () { notizSpeichern(ta); }, 600);
  });
  document.addEventListener('focusout', function (e) {
    var ta = e.target.closest && e.target.closest('[data-rd-wk-notiz]');
    if (!ta) return;
    clearTimeout(notizT);
    notizSpeichern(ta);
  });

  document.addEventListener('click', function (e) {
    var z = e.target.closest && e.target.closest('[data-rd-wk-zu]');
    if (!z) return;
    var dr = document.querySelector('cart-drawer');
    if (dr && dr.open && typeof dr.hide === 'function') { e.preventDefault(); dr.hide(); }
  });

  function nachAufbau() {
    lieferfenster();
    /* Seite: Express-Knöpfe (content_for_additional_checkout_buttons) nach dem Neuaufbau wieder anstoßen */
    if (document.querySelector('.rd-wk-seite [data-shopify="dynamic-checkout-cart"]') && window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
      try { window.Shopify.PaymentButton.init(); } catch (err) { /* Shopify-Skript fehlt im Vorschau-Kontext */ }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lieferfenster); else lieferfenster();
  document.addEventListener('cart:updated', function () { setTimeout(nachAufbau, 0); });
  document.addEventListener('rd:ship', lieferfenster);
  setInterval(lieferfenster, 60000);
})();
